export default class HeaderNavigationHandler {
  constructor() {
    this.getDependencies();
    if (!this.dependenciesAvailable()) {
      return;
    }
    this.init();
    this.events();
  }

  /**
   * Checks if all dependencies (HTMLElements) exist
   *
   * @returns {boolean} true if all elements available (not null or undefined), otherwise false
   */
  dependenciesAvailable = () => {
    if (this.html == null || this.html.length <= 0) return false;
    if (this.menuCheckbox == null || this.menuCheckbox.length <= 0) return false;
    if (this.menuOverlay == null || this.menuOverlay.length <= 0) return false;
    if (this.menuCheckboxLabel == null || this.menuCheckboxLabel.length <= 0) return false;
    if (this.menuWrapper == null || this.menuWrapper.length <= 0) return false;
    if (this.header == null || this.header.length <= 0) return false;
    if (this.nav == null || this.nav.length <= 0) return false;
    if (this.desktopMenus == null || this.desktopMenus.length <= 0) return false;


    return true;
  };

  /**
   * Retrieves the needed dependencies (HTMLElements)
   *
   * @returns {void}
   */
  getDependencies = () => {
    this.html = document.querySelector("html");
    this.menuCheckbox = document.querySelector(".js__menu_checkbox");
    this.menuOverlay = document.querySelector(".js__menu_overlay");
    this.menuCheckboxLabel = document.querySelector(".js__menu_checkbox_label");
    this.menuWrapper = document.querySelector(".js__menu_wrapper");
    this.header = document.querySelector(".js__header");
    this.nav = document.querySelector(".js__header_nav");
    this.desktopMenus = document.querySelectorAll(".js__desktop_menus");

    this.frontPageLogo = document.querySelector(".js__front_page_logo");
    // the delta for the scroll event, only used for the front page logo
    this.delta = 50;

    this.anchorElements = document.querySelectorAll("a[href^='#']");
  };

  /**
   * initialize the checkbox by default setting it to unchecked / false 
   */
  init = () => {
    this.menuCheckbox.checked = false;
  }

  /**
   * Register needed event handler
   */
  events = () => {
    /**
     * Obligatory events for toggling the menu while clicking the label
     */
    this.menuCheckbox.addEventListener('change', () => this.toggleMenu());
    this.menuCheckboxLabel.addEventListener('click', () => this.toggleMenu());

    /**
     * Open the menu when hit enter on the keyboard and the menu is closed
     */
    this.menuCheckboxLabel.addEventListener('keyup', (event) => {
      if (event.key === "Enter" && !this.menuCheckbox.checked) this.openMenu();
    });

    /**
     * Open the menu when hovering over it and the menu is closed
     * Only allow this if the menu is not open on mobile
     * Otherwise the menu would open and close immediately on the first click
     */
    this.header.addEventListener('mouseenter', () => {
      // check if the menu is not open on mobile
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) return;

      if (!this.menuCheckbox.checked) this.openMenu();
    });

    /**
     * Close the menu when leaving the menu and the menu is open
     * Only allow this if the menu is not open on mobile
     * Otherwise the menu would open and close immediately on the first click
     */
    this.header.addEventListener('mouseleave', () => {
      // check if the menu is not open on mobile
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) return;

      if (this.menuCheckbox.checked) this.closeMenu();
    });

    /**
     * Close the menu when hit escape on the keyboard and the menu is open
     */
    document.addEventListener('keyup', (event) => {
      if (event.key === "Escape" && this.menuCheckbox.checked) this.closeMenu();
    });

    /**
     * If there is any #anchor in the menu, close the menu when clicked and jump to the anchor
     */
    this.anchorElements.forEach((anchorElement) => {
      anchorElement.addEventListener('click', () => this.closeMenu());
    });

    /**
      * If the front page logo is available it disappears when scrolling down and reappears when scrolling up
      */
    if (this.frontPageLogo) {
      window.addEventListener('scroll', () => {
        this.toggleFrontPageLogo();
      });
    }

  };

  toggleFrontPageLogo = () => {
    let scrollTop = document.documentElement.scrollTop;

    if (scrollTop > this.delta) {
      // scrolling down
      this.frontPageLogo.classList.remove("invisible");
    } else {
      // scrolling up
      this.frontPageLogo.classList.add("invisible");
    }
  }

  toggleMenu = () => {
    if (this.menuCheckbox.checked) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  openMenu = () => {
    this.menuCheckbox.checked = true;
    this.html.classList.add('overflow-hidden');
    this.menuOverlay.classList.add('!pointer-events-auto', '!bg-black');
    this.menuWrapper.classList.remove('invisible'); // this is set to use tab to navigate through the menu

    if (this.frontPageLogo) {
      // this.frontPageLogo.classList.remove("invisible");
    }
  }

  closeMenu = () => {
    this.menuCheckbox.checked = false;
    this.html.classList.remove('overflow-hidden');
    this.menuOverlay.classList.remove('!pointer-events-auto', '!bg-black');
    this.menuWrapper.classList.add('invisible'); // this is set to skip the navigation when tabbing through the page

    if (this.frontPageLogo) {
      // this.toggleFrontPageLogo();
    }
  }

}